/**
 * ParaView service.
 */

const jetpack = require('fs-jetpack');
const parseTemplate = require('es6-template-strings');

import Const from '../../../constants';

const log = (global as any).log;

class ParaViewService {

    /**
     * Create start script for ParaView.
     */
    static createParaViewStartScript(caseDir, data) {
        log.debug('> Kernel.ParaViewService.createParaViewStartScript()');

        // Get directories and set output path.
        let templateDirObj = jetpack.cwd(Const.backend.configDir).cwd('paraview');
        let resultsDirObj = jetpack.cwd(caseDir).cwd('results');
        let scriptPath = resultsDirObj.path('paraview-script.py');

        // Read resultData from disk.
        let resultData = resultsDirObj.read('resultData.json', 'json');

        // Start script with echo.
        let script = templateDirObj.read('paraview-echo.py');

        // Get resultPath.
        let resultPath = resultsDirObj.path(resultData.resultPath).replace(/\\/g , '/');

        // Get beginning of python script.
        script += parseTemplate(templateDirObj.read('beginning.py'), {data: resultData, resultPath: resultPath});

        // Create main view.
        script += parseTemplate(templateDirObj.read('main-view.py'), {data: resultData});

        // Create 3D view from axi-symmetric 2D.
        if ((resultData.dimensions === 2) && resultData.isAxiSymmetric) {
            script += parseTemplate(templateDirObj.read('create-3d.py'), {data: resultData});
        }

        // Write file and return its path.
        return jetpack.writeAsync(scriptPath, script)
            .then(() => {
                return scriptPath;
            });
    }
}

export default ParaViewService;
